
import { useStore } from "@/store";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  async setup(props) {
    const products = [
      {
        id: 1,
        name: "Cold Brew Bottle",
        description:
          "This glass bottle comes with a mesh insert for steeping tea or cold-brewing coffee. Pour from any angle and remove the top for easy cleaning.",
        href: "#",
        quantity: 1,
        price: "$32.00",
        imageSrc:
          "https://tailwindui.com/img/ecommerce-images/confirmation-page-05-product-01.jpg",
        imageAlt: "Glass bottle with black plastic pour top and mesh insert.",
      },
    ];

    const store = useStore();
    const id = useRoute().params.id as string;

    if (!store.getState().posts.loaded) {
      await store.fetchPosts();
    }

    const post = store.getState().posts.all.get(id);

    if (!post) {
      throw Error("Post was not Found");
    }

    const canEdit = post.authorId === store.getState().authors.currentUserId;

    return {
      products,
      post,
      canEdit,
    };
  },
});
